import { Box, Img, Stack } from '@chakra-ui/react';
import { useContext, useState } from 'react';
import { PrimaryButton } from '../CustomButton';
import alarm from '../../assets/Group 62.svg';
import { AuthContext } from '../../context/authContext';
import { emergencyType } from '../../pages/emergency/components/emergencyType';
import { createEmergency } from '../../pages/emergency/service/createEmergency';

const NavEmergencyModal = ({ onClose }) => {
  const { userInfo } = useContext(AuthContext);
  const { tenantCode, userId } = userInfo;
  const [loading, setLoading] = useState(false);
  const [enemrgecyTypeCreated, setenemrgecyTypeCreated] = useState('');
  const type = {
    health: 'Health',
    theft: 'Theft',
    fire: 'Fire',
    others: 'Others',
  };
  const handleCreate = (type) => {
    setenemrgecyTypeCreated(emergencyType(type));
    const payload = { tenantCode, userId, type, description: 'Emergency' };

    createEmergency(payload, setLoading, onClose);
  };
  return (
    <Stack>
      <Box mx='auto' py='1rem'>
        <Img src={alarm} alt='alarm' />
      </Box>
      <Stack
        justify='center'
        align='center'
        direction='column'
        mx='auto'
        spacing='5'
      >
        <PrimaryButton
          btnText='Health'
          w='70%'
          isLoading={enemrgecyTypeCreated === 'Health' && loading}
          onClick={() => handleCreate(type.health)}
        />
        <PrimaryButton
          btnText='Theft'
          w='70%'
          isLoading={enemrgecyTypeCreated === 'Theft' && loading}
          onClick={() => handleCreate(type.theft)}
        />
        <PrimaryButton
          btnText='Fire'
          w='70%'
          isLoading={enemrgecyTypeCreated === 'Fire' && loading}
          onClick={() => handleCreate(type.fire)}
        />
        <PrimaryButton
          btnText='Others'
          w='70%'
          bg='secondary'
          isLoading={enemrgecyTypeCreated === 'Others' && loading}
          onClick={() => handleCreate(type.others)}
        />
      </Stack>
    </Stack>
  );
};

export default NavEmergencyModal;

// const buttonStyles = { bg: 'primaryDark', size: 'md', w: '70%' };
